import React from "react";
import "./TripDetails.css";
import { useQuery } from "@tanstack/react-query";
import useAirlineAdminApi from "../../../../services/api/useAirlineAdminApi";
import Loader from "../../../../components/element/Loader";
import { formatToTwoDecimal } from "../../../../utils/utils";
import { useFormData } from "../../../../helpers/FormDataProvider";

const TripDetailsPaymentSummary = ({
  flightPlanDetail,
  requiresEscortService,
  isArrivalApproved,
  isDepartureApproved,
}) => {
  const { userData } = useFormData();
  const { fetchCommercialFlightPlanFee } = useAirlineAdminApi(
    userData.isAAUser
  );

  const { data: flightPlanFeeData, isLoading } = useQuery({
    queryKey: ["get-commercial-flight-plan-fee", flightPlanDetail?.id],
    queryFn: () => fetchCommercialFlightPlanFee(flightPlanDetail?.id),
    enabled: !!flightPlanDetail?.id,
  });
  const specialOnboardingFee =
    flightPlanFeeData?.data?.arrivalEscortOfficerFee +
    flightPlanFeeData?.data?.arrivalEscortVehicleFee +
    flightPlanFeeData?.data?.departureEscortOfficerFee +
    flightPlanFeeData?.data?.departureEscortScreeningFee +
    flightPlanFeeData?.data?.departureEscortVehicleFee;

  const afterHourFee =
    flightPlanFeeData?.data?.arrivalOvertimeFee +
    flightPlanFeeData?.data?.departureOvertimeFee;

  return (
    <div className="trip-details-details-sub-container">
      {isLoading ? (
        <Loader />
      ) : (
        flightPlanFeeData?.data &&
        flightPlanFeeData?.data?.totalFee > 0 && (
          <div className="trip-details-payment-summary-container">
            <div className="trip-details-payment-summary-header">
              Payment Summary
            </div>
            <div>
              {flightPlanFeeData?.data?.scannedPassengerSecurityFee > 0 && (
                <div className="trip-details-payment-row">
                  <div className="trip-details-payment-row-container">
                    <div className="trip-details-payment-description">
                      <h3>Security Fees</h3>
                    </div>
                    <div className="trip-details-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.scannedPassengerSecurityFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              {flightPlanFeeData?.data?.landingFee > 0 && (
                <div className="trip-details-payment-row">
                  <div className="trip-details-payment-row-container">
                    <div className="trip-details-payment-description">
                      <h3>Landing Fees</h3>
                    </div>
                    <div className="trip-details-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.landingFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              {flightPlanFeeData?.data?.parkingFee > 0 && (
                <div className="trip-details-payment-row">
                  <div className="trip-details-payment-row-container">
                    <div className="trip-details-payment-description">
                      <h3>Parking Fees</h3>
                    </div>
                    <div className="trip-details-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.parkingFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}
              {(!isArrivalApproved || !isDepartureApproved) &&
                requiresEscortService &&
                specialOnboardingFee === 0.0 && (
                  <div className="edit-flight-payment-row">
                    <div className="edit-flight-payment-row-container">
                      <div className="edit-flight-payment-description">
                        <h3>Special Onboarding Fees</h3>
                      </div>
                      <div className="edit-flight-payment-amount">
                        <h3>To be calculated</h3>
                      </div>
                    </div>
                  </div>
                )}
              {specialOnboardingFee > 0 && requiresEscortService && (
                <div className="edit-flight-payment-row">
                  <div className="edit-flight-payment-row-container">
                    <div className="edit-flight-payment-description">
                      <h3>Special Onboarding Fees</h3>
                    </div>
                    <div className="edit-flight-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        specialOnboardingFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              {(flightPlanDetail?.requiresArrivalOvertime ||
                flightPlanDetail?.requiresDepartureOvertime) &&
                afterHourFee === 0.0 && (
                  <div className="edit-flight-payment-row">
                    <div className="edit-flight-payment-row-container">
                      <div className="edit-flight-payment-description">
                        <h3>After Hour Fees</h3>
                      </div>
                      <div className="edit-flight-payment-amount">
                        <h3>To be calculated</h3>
                      </div>
                    </div>
                  </div>
                )}
              {afterHourFee > 0 && (
                <div className="edit-flight-payment-row">
                  <div className="edit-flight-payment-row-container">
                    <div className="edit-flight-payment-description">
                      <h3>After Hour Fees</h3>
                    </div>
                    <div className="edit-flight-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(afterHourFee)}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              <div className="trip-details-payment-row">
                <div className="trip-details-payment-row-container">
                  <div className="trip-details-payment-description">
                    <h3>VAT</h3>
                  </div>
                  <div className="trip-details-payment-amount">
                    <h3>{`BSD ${formatToTwoDecimal(
                      flightPlanFeeData?.data?.tax
                    )}`}</h3>
                  </div>
                </div>
              </div>

              <div className="trip-details-payment-row trip-details-payment-total-row">
                <div className="trip-details-payment-row-container">
                  <div className="trip-details-payment-description">
                    <h3>Total</h3>
                  </div>
                  <div className="trip-details-payment-amount">
                    <h3>{`BSD ${formatToTwoDecimal(
                      flightPlanFeeData?.data?.totalFee
                    )}`}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default TripDetailsPaymentSummary;
